import Accordion from '../components/accordion';
import FiftyFifty from '../components/fifty-fifty/index';
import SixtyForty from '../components/sixty-forty/index';
import Fullwidth from '../components/fullwidth/index';
import HeroSection from '../components/hero-section/index';
import HeaderSection from '../components/header-section/index';

export default function populate({
    components: {
        accordion,
        fiftyFifty,
        sixtyForty,
        fullWidth,
        heroSection,
        headerSection,
        global,
        tabs
    }
}) {
    /**
     * POPULATE: Accordion
     */
    if (Array.isArray(accordion)) {
        const typeMap = {
            contentItem: content => {
                const newContentItem = document.createElement('span');
                newContentItem.classList.add('specification-content__item');
                newContentItem.textContent = content;
                return newContentItem;
            },
            subSectionHeading: content => {
                const newSubSectionHeading = document.createElement('h3');
                newSubSectionHeading.classList.add('specification-content__heading');
                newSubSectionHeading.classList.add('specification-content__heading--sub-section');
                newSubSectionHeading.textContent = content;
                return newSubSectionHeading;
            },
            contentHeading: content => {
                const newContentHeading = document.createElement('h4');
                newContentHeading.classList.add('specification-content__heading');
                newContentHeading.classList.add('specification-content__heading--content');
                newContentHeading.textContent = content;
                return newContentHeading;
            },
            contentSubHeading: content => {
                const newContentSubHeading = document.createElement('h5');
                newContentSubHeading.classList.add('specification-content__heading');
                newContentSubHeading.classList.add('specification-content__heading--content-sub');
                newContentSubHeading.textContent = content;
                return newContentSubHeading;
            }
        };
        accordion.forEach(content => {
            const instance = document.querySelector(content.selector);
            if (instance) {
                const itemElement = instance.querySelector(`.${Accordion.classNames.item}`);
                const itemElementClone = itemElement.cloneNode(true);
                instance.innerHTML = '';
                if (itemElementClone) {
                    const newsubSectionHeader = instance.previousSibling.previousSibling;
                    if (newsubSectionHeader) {
                        newsubSectionHeader.innerHTML = content.title;
                    }
                    content.items.forEach((item, index) => {
                        const newItem = itemElementClone.cloneNode(true);
                        const newItemTitle = newItem.querySelector(
                            `.${Accordion.classNames.itemTitle}`
                        );
                        const newItemContent = newItem.querySelector(
                            `.${Accordion.classNames.itemContent}`
                        );
                        if (newItemTitle) {
                            newItemTitle.innerHTML = item.title;
                        }
                        if (newItemContent) {
                            const specsTable = document.createElement('table');
                            specsTable.classList.add('specifications-content');
                            newItemContent.appendChild(specsTable);
                            item.content.forEach(lineItemData => {
                                if (lineItemData) {
                                    const specsTableRow = document.createElement('tr');
                                    specsTableRow.classList.add(
                                        'specifications-content__table-row'
                                    );
                                    const specsTableCol1 = document.createElement('td');
                                    specsTableCol1.classList.add('specifications-content__table-col');
                                    specsTableCol1.classList.add('specifications-content__table-col--heading');
                                    specsTableCol1.appendChild(
                                        typeMap.subSectionHeading(lineItemData.subSectionHeading)
                                    );
                                    const specsTableCol2 = document.createElement('td');
                                    specsTableCol2.classList.add('specifications-content__table-col');
                                    specsTableCol2.classList.add('specifications-content__table-col--items');
                                    lineItemData.sectionItems.forEach(sItem => {
                                        specsTableCol2.appendChild(
                                            typeMap[sItem.type](sItem.content)
                                        );
                                    });
                                    specsTableRow.appendChild(specsTableCol1);
                                    specsTableRow.appendChild(specsTableCol2);
                                    specsTable.appendChild(specsTableRow);
                                }
                            });
                        }
                        instance.appendChild(newItem);
                    });
                }
            }
        });
    }
    /**
     * POPULATE: fiftyFifty
     */
    if (Array.isArray(fiftyFifty)) {
        fiftyFifty.forEach(content => {
            const instance = document.querySelector(content.selector);
            if (instance) {
                const newTitle = instance.querySelector(`.${FiftyFifty.classNames.title}`);
                const newContent = instance.querySelector(`.${FiftyFifty.classNames.content}`);
                const newButton = instance.querySelector(`.${FiftyFifty.classNames.button}`);
                const newImage = instance.querySelector(`.${FiftyFifty.classNames.image}`);
                const newDisclaimer = instance.querySelector(
                    `.${FiftyFifty.classNames.disclaimer}`
                );
                if (newTitle) {
                    newTitle.innerHTML = content.title;
                }
                if (newContent) {
                    newContent.innerHTML = content.content;
                }
                if (newButton) {
                    newButton.innerHTML = content.buttonText;
                    newButton.setAttribute('href', content.buttonLink);
                }
                if (newImage) {
                    newImage.setAttribute('src', content.bgImage);
                }
                if (newDisclaimer) {
                    newDisclaimer.innerHTML = content.disclaimer;
                }
            }
        });
    }
    /**
     * POPULATE: sixtyForty
     */
    if (Array.isArray(sixtyForty)) {
        sixtyForty.forEach(content => {
            const instance = document.querySelector(content.selector);
            if (instance) {
                const newPreTitle = instance.querySelector(`.${SixtyForty.classNames.preTitle}`);
                const newTitle = instance.querySelector(`.${SixtyForty.classNames.title}`);
                const newContent = instance.querySelector(`.${SixtyForty.classNames.content}`);
                const newButton = instance.querySelector(`.${SixtyForty.classNames.button}`);
                const newImage = instance.querySelector(`.${SixtyForty.classNames.image}`);
                const newMobileImage = instance.querySelector(`.${SixtyForty.classNames.mobileImage}`);
                const newDisclaimer = instance.querySelector(
                    `.${SixtyForty.classNames.disclaimer}`
                );
                if (newPreTitle) {
                    newPreTitle.innerHTML = content.preTitle;
                }
                if (newTitle) {
                    newTitle.innerHTML = content.title;
                }
                if (newContent) {
                    newContent.innerHTML = content.content;
                }
                if (newButton) {
                    newButton.innerHTML = content.buttonText;
                    newButton.setAttribute('href', content.buttonLink);
                }
                if (newImage) {
                    newImage.setAttribute('src', content.bgImage);
                } else {
                    instance.querySelector(
                        '.sixty-forty__hasbgimage'
                    ).style.backgroundImage = `url('${content.bgImage}')`;
                }
                if (newMobileImage) {
                    newMobileImage.setAttribute('src', content.bgImage);
                }
                if (newDisclaimer) {
                    newDisclaimer.innerHTML = content.disclaimer;
                }
            }
        });
    }
    /**
     * POPULATE: fullWidth
     */
    if (Array.isArray(fullWidth)) {
        fullWidth.forEach(content => {
            const instance = document.querySelector(content.selector);
            if (instance) {
                const newTitle = instance.querySelector(`.${Fullwidth.classNames.title}`);
                const newButton = instance.querySelector(`.${Fullwidth.classNames.button}`);
                if (newTitle) {
                    newTitle.innerHTML = content.title;
                }
                if (newButton) {
                    newButton.innerHTML = content.buttonText;
                    newButton.setAttribute('href', content.buttonLink);
                }
                instance.style.backgroundColor = content.bgColor;
            }
        });
    }
    /**
     * POPULATE: heroSection
     */
    if (Array.isArray(heroSection)) {
        heroSection.forEach(content => {
            const instance = document.querySelector(content.selector);
            if (instance) {
                const newPreTitle = instance.querySelector(`.${HeroSection.classNames.preTitle}`);
                const newTitle = instance.querySelector(`.${HeroSection.classNames.title}`);
                const newCtaOne = instance.querySelector(`.${HeroSection.classNames.ctaOne}`);
                const newCtaTwo = instance.querySelector(`.${HeroSection.classNames.ctaTwo}`);
                const newBgImageDesktop = instance.querySelector(
                    `.${HeroSection.classNames.bgImageDesktop}`
                );
                const newBgImageMobile = instance.querySelector(
                    `.${HeroSection.classNames.bgImageMobile}`
                );
                if (newPreTitle) {
                    newPreTitle.innerHTML = content.preTitle;
                }
                if (newTitle) {
                    newTitle.innerHTML = content.title;
                }
                if (newCtaOne) {
                    newCtaOne.innerHTML = content.ctaOneText;
                    newCtaOne.setAttribute('href', content.ctaOneLink);
                }
                if (newCtaTwo) {
                    newCtaTwo.innerHTML = content.ctaTwoText;
                    newCtaTwo.setAttribute('href', content.ctaTwoLink);
                }
                if (newBgImageDesktop) {
                    newBgImageDesktop.style.backgroundImage = `url(${content.bgImageDesktop})`;
                }
                if (newBgImageMobile) {
                    newBgImageMobile.style.backgroundImage = `url(${content.bgImageMobile})`;
                }
            }
        });
    }
    /**
     * POPULATE: headerSection
     */
    if (Array.isArray(headerSection)) {
        headerSection.forEach(content => {
            const instance = document.querySelector(content.selector);
            if (instance) {
                const newLogoImage = instance.querySelector(
                    `.${HeaderSection.classNames.logoImage}`
                );
                const newLogoLink = instance.querySelector(`.${HeaderSection.classNames.logoLink}`);
                if (newLogoImage) {
                    newLogoImage.setAttribute('src', content.logoImage);
                }
                if (newLogoLink) {
                    newLogoLink.setAttribute('href', content.logoLink);
                }
            }
        });
    }
    /**
     * POPULATE: global and tabs
     */
    if (document.querySelector('.footer').length) {
        document.querySelector('.footer__copyright').innerHTML = global.copyright;
        document.getElementById('accordion-title-1').innerHTML = tabs['accordion-title-1'];
        document.getElementById('accordion-title-2').innerHTML = tabs['accordion-title-2'];
        document.getElementById('mobile-accordion-title-1').innerHTML = tabs['mobile-accordion-title-1'];
        document.getElementById('mobile-accordion-title-2').innerHTML = tabs['mobile-accordion-title-2'];
        document.getElementById('specifications-title').innerHTML = tabs.specificationsTitle;
    }
}
